module.exports = __webpack_public_path__ + "img/face17.719fd9d0.jpg";